import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import {
   ApplicationConfig,
   ErrorHandler,
   importProvidersFrom,
   inject,
   provideAppInitializer,
   provideZoneChangeDetection,
} from '@angular/core';
import {
   provideRouter,
   withComponentInputBinding,
   withInMemoryScrolling,
   withRouterConfig,
} from '@angular/router';
import { AuthModule } from '@auth0/auth0-angular';
import { environment } from '@env';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
// perfect scrollbar
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgScrollbarModule } from 'ngx-scrollbar';
//Import all material modules
import { MatNativeDateModule } from '@angular/material/core';
import { ErrorHandlerService } from '@core/services/error-handler.service';
import { AuthService as CoreAuthService } from '@core/services/auth.service';
import { PwaInstallService } from '@core/services/pwa-install.service';
import { provideNgxMask } from 'ngx-mask';
import { APP_ROUTES } from './app.routes';

export const appConfig: ApplicationConfig = {
   providers: [
      { provide: ErrorHandler, useClass: ErrorHandlerService },
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideRouter(
         APP_ROUTES,
         withInMemoryScrolling({
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
         }),
         withComponentInputBinding(),
         withRouterConfig({ paramsInheritanceStrategy: 'emptyOnly' })
      ),
      provideHttpClient(withXhr(), withInterceptorsFromDi()),
      //provideClientHydration(withIncrementalHydration()),
      provideTranslateService({
         loader: provideTranslateHttpLoader({
            prefix: '/assets/i18n/',
            suffix: '.json',
         }),
         fallbackLang: 'pt-BR',
         lang: 'pt-BR',
      }),
      provideNgxMask(),
      provideAppInitializer(() => {
         inject(PwaInstallService).initialize();
         return inject(CoreAuthService).initializeUniversalLogin();
      }),
      importProvidersFrom(
         MatNativeDateModule,
         NgxPermissionsModule.forRoot(),
         NgScrollbarModule,
         AuthModule.forRoot({
            domain: environment.auth0Config.domain,
            clientId: environment.auth0Config.clientID,
            authorizationParams: {
               audience: environment.auth0Config.audience,
               redirect_uri: environment.auth0Config.redirectUri,
               scope: `${environment.auth0Config.scope} offline_access`,
            },
            cacheLocation: 'localstorage',
            useRefreshTokens: true,
            useRefreshTokensFallback: false,
         })
      ),
      // {
      //    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      //    useValue: { subscriptSizing: 'dynamic' },
      // },
   ],
};
